import { Pipe, PipeTransform } from '@angular/core'

/**
 * Pipe que permite obtener un objeto de un arreglo externo, buscándolo por un campo específico.
 * @param arreglo - El arreglo externo del cual se desea obtener el objeto.
 * @param campoLigar - El campo por el cual se va a buscar el objeto en el arreglo.
 * @param valorCampo - El valor del campo por el cual se va a buscar el objeto en el arreglo.
 * @returns El objeto encontrado en el arreglo, o undefined si no se encuentra.
 */
@Pipe({
  name: 'ligarArreglo',
  pure: true
})
export class LigarArregloPipe implements PipeTransform {
  transform(arreglo: Array<any>, campoLigar: string, valorCampo: any): any {
    return arreglo.find(datos => datos[campoLigar] === valorCampo)
  }
}
